import { startCase } from 'lodash-es';

import AccountSettings from '@/bundles/Account/models/AccountSettings';
import { Nullable } from '@/utils/types';

export type MarketColumnsRecordType = 'property' | 'comparable';

export interface IMarketColumns {
  one: string;
  two: Nullable<string>; // null hides the second market column
}

// Geo_Market layer names the list columns read when the account has no market settings.
const defaultMarketLayers: Record<MarketColumnsRecordType, [string, string]> = {
  property: ['submarket cluster', 'business park'],
  comparable: ['submarket cluster', 'submarket'],
};

const LOS_ANGELES_ACCOUNT_ID = 6;

const formatMarketLabel = (layerName: string): string => {
  const name = layerName.trim().toLowerCase();
  // LA names its Submarket layer in the plural
  if (name === 'submarkets') {
    return 'Submarket';
  }
  return startCase(name);
};

/**
 * Labels for the two market columns of the property and comparable lists.
 * The columns show the record's polygon in the Geo_Market layers named by the
 * <recordType>FilterMarketOne / <recordType>FilterMarketTwo account settings.
 */
export const getMarketColumns = (
  accountId: number | undefined,
  accountSettings: Nullable<Partial<AccountSettings>> | undefined,
  recordType: MarketColumnsRecordType,
): IMarketColumns => {
  const [defaultLayerOne, defaultLayerTwo] = defaultMarketLayers[recordType];
  const one = formatMarketLabel(accountSettings?.[`${recordType}FilterMarketOne` as const] || defaultLayerOne);
  const two = formatMarketLabel(accountSettings?.[`${recordType}FilterMarketTwo` as const] || defaultLayerTwo);
  const isSecondColumnHidden = accountId === LOS_ANGELES_ACCOUNT_ID || one === two;

  return { one, two: isSecondColumnHidden ? null : two };
};
